<template>
  <div class="col-lg-4 col-md-6">
    <div class="single-product">
      <div class="product-img">
        <a :href="`/products/${product.slug}`" v-on:click="trackClick">
          <img class="img-fluid w-100" :src="product.image_url" :alt="product.name" />
        </a>
        <div class="p_icon">
          <Preview :slug="product.slug" />
          <Buy :item="product" />
        </div>
      </div>
      <div class="product-btm">
        <a :href="`/products/${product.slug}`" class="d-block">
          <h4>{{product.name}}</h4>
        </a>
        <div class="mt-3">
          <span class="mr-4">${{product.price}}</span>
          <del>${{product.price * 3}}</del>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Buy from '@/components/BuyIcon'
import Preview from '@/components/PreviewButton'
export default {
  props: ['product'],
  components: {
    Buy,
    Preview
  },
  methods: {
    trackClick (e) {
      window.analytics.track('Viewed Product From Image', this.product)
    }
  }
}
</script>
<style lang="scss">
@import "../assets/scss/_variables.scss";
@import "../assets/scss/_button.scss";
@import "../assets/scss/_product.scss";
</style>



// WEBPACK FOOTER //
// src/components/Product.vue